import { createContext } from 'react';
import { rootStore } from './RootStore';
import type { RootStore } from './RootStore';

export const StoreContext = createContext<RootStore>(rootStore);
